export interface DisabledINSITooltipWrapperProps {
  display: boolean
  children: JSX.Element
}

export const TOOLTIP_CONTENT_DISABLED_INSI_FIELDS =
  "L'identité a été récupérée via INSI, ce champ n'est plus modifiable"
